import { render } from "./OnboardingSecondStep.vue?vue&type=template&id=03b82868&scoped=true&ts=true"
import script from "./OnboardingSecondStep.vue?vue&type=script&lang=ts"
export * from "./OnboardingSecondStep.vue?vue&type=script&lang=ts"

import "./OnboardingSecondStep.vue?vue&type=style&index=0&id=03b82868&lang=scss&scoped=true"

import exportComponent from "/home/franco/Desarrollos/NC/gramosDev/Gramos/FrontEnd/trunk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b82868"]])

export default __exports__